var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5869 15.107H11.5434C10.1348 15.107 8.99997 13.9722 8.99997 12.5635C8.99997 11.1548 10.1348 10.02 11.5434 10.02H36.5869C37.9956 10.02 39.1304 11.1548 39.1304 12.5635C39.1304 13.9722 37.9956 15.107 36.5869 15.107ZM39.1304 23.9113C39.1304 22.5026 37.9956 21.3678 36.5869 21.3678H11.5434C10.1348 21.3678 8.99997 22.5026 8.99997 23.9113C8.99997 25.32 10.1348 26.4548 11.5434 26.4548H36.5869C37.9956 26.4548 39.1304 25.32 39.1304 23.9113ZM39.1304 35.2592C39.1304 33.8505 37.9956 32.7157 36.5869 32.7157H11.5434C10.1348 32.7157 8.99997 33.8505 8.99997 35.2592C8.99997 36.6678 10.1348 37.8026 11.5434 37.8026H36.5869C37.9956 37.8026 39.1304 36.6678 39.1304 35.2592Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.3d3fd8444f66ce33fd0978ca7cddc03c.svg";
export { ForwardRef as ReactComponent };